import script from "./PageHead.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHead.vue?vue&type=script&setup=true&lang=js"

import "./PageHead.vue?vue&type=style&index=0&id=8f09dd3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f09dd3c"]])

export default __exports__